<!-- eslint-disable no-nested-ternary -->
<template>
  <b-card no-body>
    <b-card-header :class="{ 'pb-0': !padding, 'pb-1': padding }">
      <!-- title and subtitle -->
      <div>
        <b-card-title class="font-weight-bolder mb-1">
          {{ dataCart.title }}
        </b-card-title>
        <b-card-sub-title>
          {{ dataCart.subTitle }}
        </b-card-sub-title>
      </div>
    </b-card-header>

    <b-card-body>
      <!-- <b-button-group size="sm">
        <b-button
          :class="seriActive==='yesterday'?'active':''"
          variant="outline-primary"
          @click="actionFilter('yesterday')"
        >
          Yesterday
        </b-button>
        <b-button
          :class="seriActive==='last7days'?'active':''"
          variant="outline-primary"
          @click="actionFilter('last7days')"
        >
          Last 7 Days
        </b-button>
        <b-button
          :class="seriActive==='thismonth'?'active':''"
          variant="outline-primary"
          @click="actionFilter('thismonth')"
        >
          This Month
        </b-button>
      </b-button-group> -->
      <div
        v-if="total"
        class="d-flex flag-icon pt-6 pb-25 pl-1 text-white"
        :class="[color]"
      >
        <b-col class="col-10">
          <h2 class="text-white h-l">
            <span>Total</span> {{ formatPrice(dataCart.total) }}
          </h2>
        </b-col>
        <b-col class="col-2">
          <div
            class="feath"
            v-html="getFeather(feather)"
          />
        </b-col>
      </div>
      <vue-apex-charts
        ref="apex"
        type="bar"
        height="300"
        :options="dTrafficPerform.options"
        :series="dTrafficPerform.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  BCol,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { mapActions } from 'vuex'
// import flatPickr from 'vue-flatpickr-component'
// import apexChatData from './apexChartData'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCol,
    // flatPickr,
    // BButtonGroup,
    // BButton,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataCart: Object,
    horizontal: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    title: String,
    // eslint-disable-next-line vue/require-default-prop
    subTitle: String,
    feather: {
      type: String,
      default: '',
    },
    total: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    let Self = this
    return {
      seriActive: 'today',
      totalRevenue: 0,
      dTrafficPerform: {
        series: [
          {
            data: [],
          },
        ],
        options: {
          chart: {
            height: '300px',
            toolbar: {
              show: false,
            },
          },
          colors: [
            '#6EC5B9',
            '#A2DAD2',
            '#C3E7E2',
            '#D2EDE9',
            '#DDF2EF',
            '#E8F6F4',
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              barHeight: '80',
              columnWidth: '45',
              endingShape: 'rounded',
              distributed: true,
            },
          },
          legend: {
            show: false,
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: true,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [],
            offsetX: 4,
            tickAmount: 7,
            labels: {
              style: {
                cssClass: 'text-left',
              },
            },
          },
          yaxis: {
            // opposite: isRtl,
            // eslint-disable-next-line no-unused-vars
            formatter: value => value,
          },
          states: {
            hover: {
              filter: {
                type: 'darken',
                value: 0.35,
              },
            },
          },
          tooltip: {
            theme: 'dark',
            fillSeriesColor: false,
            x: {
              show: false,
            },
            y: {
              title: {
                formatter() {
                  return ''
                },
              },
            },
          },
        },
      },
      xaxisCurency: {
        formatter(value) {
          return Self.convertCurrency(value)
        },
      },
      tooltipNominal: {
        y: {
          formatter(value) {
            return Self.convertNomina(value)
          },
        },
      },
    }
  },
  beforeMount() {
    // this.setData()
    // this.setCategories()
    // this.setColor()
    // this.setType()
    // this.setGridLine()
    // this.actionFilter('today')
  },
  mounted() {
    // console.log(this.dataCart.data)
  },
  methods: {
    ...mapActions('dashboard', [
      'getTrafficPerform',
      'getClickPerform',
      'getSalesConversion',
      'getMostInventory',
      'getMostPurchase',
      'getMostIndustry',
    ]),
    getFeather(svg) {
      if (svg === 'eye') {
        return '<svg width="32" height="20" viewBox="0 0 36 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.3882 10.7947C35.2038 11.8133 35.2038 13.1884 34.3882 14.2053C31.8193 17.4072 25.6559 24 18.4602 24C11.2644 24 5.10106 17.4072 2.53214 14.2053C2.13533 13.7176 1.91992 13.1176 1.91992 12.5C1.91992 11.8824 2.13533 11.2824 2.53214 10.7947C5.10106 7.59279 11.2644 1 18.4602 1C25.6559 1 31.8193 7.59279 34.3882 10.7947V10.7947Z" stroke="black" stroke-opacity="0.15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.4608 17.4284C21.3116 17.4284 23.6227 15.2218 23.6227 12.4999C23.6227 9.77789 21.3116 7.57129 18.4608 7.57129C15.6099 7.57129 13.2988 9.77789 13.2988 12.4999C13.2988 15.2218 15.6099 17.4284 18.4608 17.4284Z" stroke="black" stroke-opacity="0.15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      } if (svg === 'click') {
        return '<svg width="32" height="20" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.82641 0C9.02905 0 9.22339 0.0836572 9.36668 0.232568C9.50997 0.381478 9.59046 0.583444 9.59046 0.794036V3.97018C9.59046 4.18077 9.50997 4.38274 9.36668 4.53165C9.22339 4.68056 9.02905 4.76421 8.82641 4.76421C8.62378 4.76421 8.42944 4.68056 8.28615 4.53165C8.14286 4.38274 8.06237 4.18077 8.06237 3.97018V0.794036C8.06237 0.583444 8.14286 0.381478 8.28615 0.232568C8.42944 0.0836572 8.62378 0 8.82641 0ZM2.88211 2.55679C2.95309 2.48285 3.0374 2.42418 3.13022 2.38415C3.22305 2.34412 3.32256 2.32352 3.42306 2.32352C3.52356 2.32352 3.62307 2.34412 3.71589 2.38415C3.80872 2.42418 3.89303 2.48285 3.96401 2.55679L6.12474 4.80392C6.19771 4.87716 6.25592 4.96478 6.29596 5.06166C6.336 5.15853 6.35708 5.26273 6.35796 5.36816C6.35885 5.47359 6.33951 5.57815 6.3011 5.67573C6.26268 5.77331 6.20595 5.86197 6.13421 5.93652C6.06247 6.01108 5.97716 6.07004 5.88326 6.10996C5.78936 6.14989 5.68875 6.16998 5.5873 6.16906C5.48585 6.16815 5.3856 6.14624 5.29238 6.10463C5.19916 6.06301 5.11485 6.00252 5.04437 5.92668L2.88364 3.68115C2.7404 3.53225 2.65994 3.33032 2.65994 3.11977C2.65994 2.90922 2.7404 2.70729 2.88364 2.55838L2.88211 2.55679ZM14.7707 2.55679C14.8419 2.63055 14.8983 2.71818 14.9368 2.81464C14.9754 2.91111 14.9952 3.01453 14.9952 3.11897C14.9952 3.22342 14.9754 3.32683 14.9368 3.4233C14.8983 3.51977 14.8419 3.60739 14.7707 3.68115L12.6069 5.92668C12.5364 6.00252 12.4521 6.06301 12.3589 6.10463C12.2657 6.14624 12.1654 6.16815 12.064 6.16906C11.9625 6.16998 11.8619 6.14989 11.768 6.10996C11.6741 6.07004 11.5888 6.01108 11.5171 5.93652C11.4454 5.86197 11.3886 5.77331 11.3502 5.67573C11.3118 5.57815 11.2925 5.47359 11.2933 5.36816C11.2942 5.26273 11.3153 5.15853 11.3553 5.06166C11.3954 4.96478 11.4536 4.87716 11.5266 4.80392L13.6873 2.55838C13.8306 2.40952 14.0249 2.3259 14.2275 2.3259C14.4301 2.3259 14.6244 2.40952 14.7677 2.55838L14.7707 2.55679ZM0.421875 8.73439C0.421875 8.5238 0.502373 8.32184 0.64566 8.17292C0.788947 8.02401 0.983286 7.94036 1.18592 7.94036H4.24212C4.44476 7.94036 4.6391 8.02401 4.78238 8.17292C4.92567 8.32184 5.00617 8.5238 5.00617 8.73439C5.00617 8.94498 4.92567 9.14695 4.78238 9.29586C4.6391 9.44477 4.44476 9.52843 4.24212 9.52843H1.18592C0.983286 9.52843 0.788947 9.44477 0.64566 9.29586C0.502373 9.14695 0.421875 8.94498 0.421875 8.73439ZM10.5684 8.41678C10.3454 8.22374 10.0741 8.1007 9.78631 8.06204C9.49847 8.02338 9.206 8.07071 8.9431 8.19849C8.6802 8.32627 8.45775 8.52921 8.30178 8.78358C8.14581 9.03794 8.06276 9.33321 8.06237 9.63483V24.0879C8.06237 25.5552 9.81204 26.2381 10.7411 25.1344L13.837 21.4564C14.0524 21.2012 14.3177 20.9968 14.6152 20.8569C14.9128 20.7169 15.2357 20.6447 15.5623 20.6449H20.469C21.8978 20.6449 22.5457 18.7869 21.447 17.8372L10.5684 8.41519V8.41678ZM9.59046 24.091V9.63483L20.469 19.0569H15.5623C15.0176 19.0568 14.4792 19.1778 13.9832 19.4117C13.4872 19.6456 13.045 19.987 12.6864 20.4131L9.59046 24.0895V24.091Z" fill="#000" fill-opacity="0.15"/></svg>'
      } if (svg === 'dollar') {
        return '<svg width="32" height="20" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3332 8.00008V7.40008C15.3332 7.00008 15.0665 6.73341 14.6665 6.73341C14.2665 6.73341 13.9998 7.00008 13.9998 7.40008V8.00008C13.9998 11.3334 11.3332 14.0001 7.99984 14.0001C4.6665 14.0001 1.99984 11.3334 1.99984 8.00008C1.99984 4.66675 4.6665 2.00008 7.99984 2.00008C8.8665 2.00008 9.6665 2.20008 10.4665 2.53341C10.7998 2.66675 11.1998 2.53341 11.3332 2.20008C11.4665 1.86675 11.3332 1.46675 10.9998 1.33341C10.0665 0.866748 8.99984 0.666748 7.99984 0.666748C3.93317 0.666748 0.666504 3.93341 0.666504 8.00008C0.666504 12.0667 3.93317 15.3334 7.99984 15.3334C12.0665 15.3334 15.3332 12.0667 15.3332 8.00008ZM14.8665 1.53341C15.1332 1.26675 15.5332 1.26675 15.7998 1.53341C16.0665 1.80008 16.0665 2.20008 15.7998 2.46675L8.4665 9.80008C8.33317 9.93342 8.13317 10.0001 7.99984 10.0001C7.8665 10.0001 7.6665 9.93342 7.53317 9.80008L5.53317 7.80008C5.2665 7.53341 5.2665 7.13341 5.53317 6.86675C5.79984 6.60008 6.19984 6.60008 6.4665 6.86675L7.99984 8.40008L14.8665 1.53341Z" fill="black" fill-opacity="0.2"/></svg>'
      }
      return ''
    },
    convertCurrency(v) {
      if (typeof v === 'string' || v instanceof String) {
        return v
      }
      if (Math.abs(Number(v)) >= 1.0e9) return `${(Math.abs(Number(v)) / 1.0e9).toFixed(1)}B`.replace('.0', '')
      if (Math.abs(Number(v)) >= 1.0e6) return `${(Math.abs(Number(v)) / 1.0e6).toFixed(1)}M`.replace('.0', '')
      if (Math.abs(Number(v)) >= 1.0e3) return `${(Math.abs(Number(v)) / 1.0e3).toFixed(1)}K`.replace('.0', '')

      return v.toFixed(1).replace('.0', '')
    },
    convertNomina(v) {
      let val = (v / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    setData() {
      this.dTrafficPerform.series[0].data = this.dataCart.data
    },
    setCategories() {
      this.dTrafficPerform.options.xaxis.categories = this.dataCart.categories
    },
    setColor() {
      this.dTrafficPerform.options.colors = this.dataCart.color
    },
    setType() {
      this.dTrafficPerform.options.plotOptions.bar.horizontal = this.horizontal
      if (this.horizontal === true) {
        this.dTrafficPerform.options.plotOptions.bar.barHeight = '70'
      }
    },
    setGridLine() {
      this.dTrafficPerform.options.grid.xaxis.lines.show = !!this.horizontal
      this.dTrafficPerform.options.grid.yaxis.lines.show = !this.horizontal
    },
    setCurrencyX(dm = 7) {
      this.dTrafficPerform.options.xaxis.labels = this.xaxisCurency
      this.dTrafficPerform.options.xaxis.tickAmount = dm
    },
    setCurrencyY(dm = 7) {
      this.dTrafficPerform.options.yaxis.labels = this.xaxisCurency
      this.dTrafficPerform.options.yaxis.tickAmount = dm
    },
    setNominal() {
      this.dTrafficPerform.options.tooltip = this.tooltipNominal
    },
    actionFilter(type) {
      this.seriActive = type
      switch (this.dataCart.title) {
        case 'Traffic Performance':
          this.getTrafficPerform(type).then(() => {
            this.setData()
            this.setCategories()
            this.setColor()
            this.setType()
            this.setGridLine()
            this.setCurrencyX(4)
            this.setNominal()
            this.$refs.apex.updateOptions(this.dTrafficPerform.options)
            this.$refs.apex.updateSeries(this.dTrafficPerform.series)
          })
          break
        case 'Click Performance':
          this.getClickPerform(type).then(() => {
            this.setData()
            this.setCategories()
            this.setColor()
            this.setType()
            this.setGridLine()
            this.setCurrencyY(4)
            this.setNominal()
            this.$refs.apex.updateOptions(this.dTrafficPerform.options)
            this.$refs.apex.updateSeries(this.dTrafficPerform.series)
            // this.Revenue = this.
          })
          break
        case 'Sales Conversion':
          this.getSalesConversion(type).then(() => {
            this.setData()
            this.setCategories()
            this.setColor()
            this.setType()
            this.setGridLine()
            this.setCurrencyX(4)
            this.setNominal()
            this.$refs.apex.updateOptions(this.dTrafficPerform.options)
            this.$refs.apex.updateSeries(this.dTrafficPerform.series)
          })
          break
        case 'Most Purchase Inventory':
          this.getMostInventory(type).then(() => {
            this.setData()
            this.setCategories()
            this.setColor()
            this.setType()
            this.setGridLine()
            this.setCurrencyX(4)
            this.setNominal()
            this.$refs.apex.updateOptions(this.dTrafficPerform.options)
            this.$refs.apex.updateSeries(this.dTrafficPerform.series)
          })
          break
        case 'Top 6 Most Industries':
          this.getMostIndustry(type).then(() => {
            this.setData()
            this.setCategories()
            this.setColor()
            this.setType()
            this.setGridLine()
            this.$refs.apex.updateOptions(this.dTrafficPerform.options)
            this.$refs.apex.updateSeries(this.dTrafficPerform.series)
          })
          break
        default:
          break
      }
    },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>

<style scoped>
.bg-color-1 {
  background-color: #a3d9d1 !important;
}
.bg-color-2 {
  background-color: #486ca8 !important;
}
.bg-color-3 {
  background-color: #eacf73 !important;
}
.feath{
  text-align: center;
}
.h-l{
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 0px !important;
}
.h-l span{
  font-size: 1.4rem;
  font-weight: 300;
}

.pt-6{
  padding-top: 0.6rem !important;
}
</style>
